<div class="sso-callback-container">
  <div class="sso-card">
    <div class="card-header">
      <h1>AllUnited AI Planner</h1>
      <p class="subtitle">Syncing with AllUnited backoffice</p>
    </div>

    <div class="card-body">
      <div class="status-section">
        <!-- Error State -->
        <div *ngIf="error" class="error-message">
          <div class="error-icon">✗</div>
          <h2>Authentication Failed</h2>
          <p>{{ error }}</p>
          <button mat-raised-button color="warn" (click)="router.navigate(['/login'])">
            Return to Login
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="!error" class="loading-section">
          <div class="spinner-container">
            <mat-spinner *ngIf="status !== 'completed'" diameter="80"></mat-spinner>
            <div *ngIf="status === 'completed'" class="checkmark-icon">✓</div>
          </div>

          <div class="progress-info">
            <h2>{{ message }}</h2>
            <mat-progress-bar
              mode="determinate"
              [value]="progress"
              class="progress-bar">
            </mat-progress-bar>
            <p class="progress-text">{{ progress }}%</p>
          </div>

          <div class="status-details" *ngIf="status !== 'starting'">
            <div class="status-step" [class.active]="status === 'fetching' || progress > 10" [class.complete]="progress > 30">
              <span class="step-number">1</span>
              <span class="step-label">Connecting to AllUnited</span>
            </div>
            <div class="status-step" [class.active]="status === 'creating_org' || progress > 30" [class.complete]="progress > 50">
              <span class="step-number">2</span>
              <span class="step-label">Setting up organization</span>
            </div>
            <div class="status-step" [class.active]="status === 'syncing_resources' || progress > 50" [class.complete]="progress > 90">
              <span class="step-number">3</span>
              <span class="step-label">Importing resources</span>
            </div>
            <div class="status-step" [class.active]="status === 'completed' || progress === 100" [class.complete]="progress === 100">
              <span class="step-number">4</span>
              <span class="step-label">Finalizing</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
